import { filter, get, uniq, isEmpty } from "lodash";
import { Field, FieldArray, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import {
  FieldDropSide,
  SearchableList,
  CsplTable as Table,
  FieldInputDollar,
  FieldInput,
  PayrollCardHeader,
  PayrollCardBody,
} from "../../../components";
import {
  getNullTableItem,
  OPTIONS_DATA_MAPPER,
  toOptionValuesFromMapper,
  usDateFormat,
} from "../../../utils";
import { useDeepEffect } from "../../../abstracts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTrashAlt,
  faTimes,
  faExclamationTriangle,
} from "@fortawesome/pro-light-svg-icons";
import { Button, Modal } from "react-bootstrap";
import { faSort } from "@fortawesome/pro-solid-svg-icons";

// const paydates = [
//   { label: "12/01/2021", value: "12/01/2021" },
//   { label: "13/02/2021", value: "13/02/2021" },
//   { label: "14/03/2021", value: "14/03/2021" },
// ];
// let x = paydates.length === 1 ? paydates[0].value : null;

const headerData = [
  {
    label: "Plan Details",
    className: "column-compensation-plan-details",
    icon: faSort,
  },
  {
    label: "Amount",
    className: "column-compensation-amount",
    icon: faSort,
  },
  {
    label: "Action",
    className: "column-compensation-action pl-1",
  },
];

const getIndexOfTable = (controlName) => {
  switch (controlName) {
    case "payPeriodGrossCompensation":
      return 0;
      break;
    case "payPeriodPlanCompensation":
      return 1;
      break;
    case "ytdGrossCompensation":
      return 0;
      break;
    case "ytdPlanCompensation":
      return 1;
      break;
    default:
      return -1;
      break;
  }
};

const PayrollCompensationDetails = ({
  fields,
  data,
  paydate,
  pendingSubmission,
  compensationError,
  error,
  setErrors,
  errorList,
  isWarningSlide,
}) => {
  const { values, setFieldValue, handleChange, errors } = useFormikContext();
  const compensationDetails = get(values, fields.compensations, []);
  const [isModalOpen, setIsModalOpen] = useState(0);
  const [filteredValues, setFilteredValues] = useState([]);
  const [recordToDelete, setRecordToDelete] = useState({});
  const [showClass, setShowClass] = useState(true);
  const [payDates, setPayDates] = useState([]);
  const [compError, setCompError] = useState([]);
  // useDeepEffect(() => {
  //   setFieldValue(fields.compensations, data);
  // }, [data]);
  let temp = data.map((_) => _.payDate);
  let paydates = temp.map((_) => usDateFormat(_));
  let uniquepaydates = [...new Set(paydates)];
  let x = uniquepaydates.length === 1 ? uniquepaydates[0] : null;

  useDeepEffect(() => {
    setFilteredValues(
      data.filter(
        (compensation) => compensation.payDate === values[fields.paydate]
      )
    );
  }, [values[fields.paydate]]);

  useDeepEffect(() => {
    const tempPayDates = data.map((compensation) => compensation.payDate);

    setPayDates(
      tempPayDates.filter(
        (item, i, tempPayDates) => tempPayDates.indexOf(item) === i
      )
    );
  }, [data]);

  const compensationDetailsRecordType =
    values[fields.compensationDetailsRecordType];

  // useDeepEffect(
  //   () => {
  //     setFieldValue(
  //       fields.compensationDetails,
  //       filter(data, (item) => {
  //         return (
  //           !compensationDetailsRecordType ||
  //           (compensationDetailsRecordType === 1 && item.isError)
  //         );
  //       })
  //     );
  //   },
  //   [compensationDetailsRecordType],
  //   true
  // );

  useEffect(() => {
    setFilteredValues(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const removeOne = (item, index) => {
    setIsModalOpen(true);
    setRecordToDelete(item);
  };

  const onDeleteConfirmClick = () => {
    const selectedId = get(recordToDelete, "planId");
    setFilteredValues(
      filteredValues.filter((item) => {
        return item.planId !== selectedId;
      })
    );
    setIsModalOpen(false);
    setRecordToDelete({});
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setRecordToDelete({});
  };

  const fullText = () => {
    setShowClass(!showClass);
  };

  const check = (errorMsg) => {
    const errorId = error.filter((_) => _.messageDescCode == errorMsg);
    if (!isEmpty(errorId)) {
      setCompError([...compError, errorId[0].id]);
      compensationError([...compError, errorId[0].id]);
    }
  };

  const handleCompensationChange = (e, mode, type, name, index) => {
    const current = e.target.value;
    const fieldValue =
      mode === 2
        ? `${fields.compensationDetails}[${index}].payPeriodAmount`
        : `${fields.compensationDetails}[${index}].ytdAmount`;
    if (mode === 1) {
      if (type === 1) {
        const prevPayGross = get(values, name);
        const planGrosscomp =
          get(values, fieldValue) + (current - prevPayGross);
        setFieldValue(
          `${fields.compensationDetails}[${index}].ytdAmount`,
          planGrosscomp
        );
        handleChange(e);
      } else {
        const prevYTDGross = get(values, name);
        const YTDGrossComp = get(values, fieldValue) + (current - prevYTDGross);
        setFieldValue(
          `${fields.compensationDetails}[${index}].payPeriodAmount`,
          YTDGrossComp
        );
        handleChange(e);
      }
    } else {
      if (type === 1) {
        const prevPayPlan = get(values, name);
        const payplanComp = get(values, fieldValue) + (current - prevPayPlan);
        setFieldValue(
          `${fields.compensationDetails}[${index}].payPeriodAmount`,
          payplanComp
        );
        handleChange(e);
      } else {
        const prevYTDPlan = get(values, name);
        const payTYDComp = get(values, fieldValue) + (current - prevYTDPlan);

        setFieldValue(
          `${fields.compensationDetails}[${index}].ytdAmount`,
          payTYDComp
        );
        handleChange(e);
      }
    }
  };
  return (
    <div className="payroll-compensation-details">
      <div className="plan-sub-heading mtb5 fw-600">Compensation Details</div>
      <div className="ft-12 mb-20">
        Review and correct the compensation amounts. Use the action buttons
        above to update the employee’s record
      </div>
      <div className="d-flex justify-content-start">
        <Field
          isRequired
          label="Show"
          size="smd"
          disabled={pendingSubmission || isWarningSlide}
          placeholder="Show"
          name={`fields.compensationDetailsRecordType`}
          value={values[fields.compensationDetailsRecordType]}
          direction="bottom"
          options={toOptionValuesFromMapper(
            OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
          )}
          popupContent={
            <SearchableList
              label="Select record type"
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.RECORD_TYPES_OPTIONS
              )}
              onSelect={(value) =>
                setFieldValue(fields.compensationDetailsRecordType, value)
              }
              selectedValue={values[fields.compensationDetailsRecordType]}
              name={fields.compensationDetailsRecordType}
              isNotTypeAhead
              isRadio
            />
          }
          component={FieldDropSide}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Field
          isRequired
          label="Pay date"
          size="sm"
          placeholder=""
          name={fields.paydate}
          value={x}
          disabled={
            x
              ? true
              : false || pendingSubmission || isEmpty(data) || isWarningSlide
          }
          direction="bottom"
          component={FieldInput}
        />
      </div>
      <FieldArray name={fields.compensationDetails}>
        {({ push, remove }) => {
          return (
            <div className="payroll-card-container">
              <PayrollCardHeader headerData={headerData} />
              {!isEmpty(filteredValues) ? (
                <>
                  {filteredValues.map((compensation, index) => {
                    const isError =
                      get(
                        errorList,
                        `compensations[${index}].payPeriodAmount`
                      ) != undefined
                        ? true
                        : false;

                    const isErrorYtdAmount =
                      get(errorList, `compensations[${index}].ytdAmount`) !=
                      undefined
                        ? true
                        : false;

                    const errorType = values.errorMessages
                      .filter((X) => X.errorType === 2)
                      .map((_) => getIndexOfTable(_.controlName))
                      .includes(index);

                    return compensation.compensationType ? (
                      <>
                        <PayrollCardBody
                          values={values}
                          index={index}
                          compensationType={
                            compensation["compensationType"]?.toLowerCase() ===
                            "GROSS COMPENSATION".toLowerCase()
                              ? "Pay Period Gross"
                              : "Pay Period Plan"
                          }
                          fieldName={`${fields.compensationDetails}[${index}].payPeriodAmount`}
                          disabled={
                            values.modeOfCompensation != 1 ||
                            pendingSubmission ||
                            isWarningSlide
                          }
                          errorList={errorList}
                          check={check}
                          errorType={errorType ? 2 : 1}
                          compensation={compensation}
                          showClass={showClass}
                          fullText={fullText}
                          showAcceptWarning={
                            values.modeOfCompensation === 1 &&
                            isError &&
                            errorType
                          }
                          handleCompensationChange={handleCompensationChange}
                          isCompensation={true}
                        />
                        <PayrollCardBody
                          values={values}
                          index={index}
                          compensationType={
                            compensation["compensationType"]?.toLowerCase() ===
                            "GROSS COMPENSATION".toLowerCase()
                              ? "Calendar YTD Gross"
                              : "Calendar YTD Plan"
                          }
                          fieldName={`${fields.compensationDetails}[${index}].ytdAmount`}
                          disabled={
                            values.modeOfCompensation == 1 ||
                            pendingSubmission ||
                            isWarningSlide
                          }
                          errorList={errorList}
                          check={check}
                          errorType={errorType ? 2 : 1}
                          showAcceptWarning={
                            values.modeOfCompensation !== 1 &&
                            isErrorYtdAmount &&
                            errorType
                          }
                          compensation={compensation}
                          showClass={showClass}
                          fullText={fullText}
                          handleCompensationChange={handleCompensationChange}
                          isCompensation={true}
                        />
                      </>
                    ) : null;
                  })}
                </>
              ) : (
                <div className="d-flex justify-content-center payroll-accept-card">
                  No data available
                </div>
              )}
            </div>
          );
        }}
      </FieldArray>
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Body style={{ borderTop: "5px solid #f94f50" }}>
          <div className="text-right">
            <FontAwesomeIcon
              icon={faTimes}
              color="#000"
              onClick={handleClose}
            />
          </div>
          <div className="d-flex">
            <div className="pd-15">
              <FontAwesomeIcon
                icon={faExclamationTriangle}
                color="#f94f50"
                size="3x"
              />
            </div>
            <div className="remove-text">
              <h4>Delete Error ?</h4>
              <p>
                Are you sure you want to delete selected Compensation details?
                Deleted information cannot be retrieved or restored
              </p>
              <br />
              <Button
                className="remove-btn mr-4"
                onClick={onDeleteConfirmClick}
              >
                Delete
              </Button>
              <Button className="cancel-btn" onClick={handleClose}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PayrollCompensationDetails;
